import { INBODY_COLORS } from "@inbody/core";
function getAvatarInitial(name) {
  const trimmed = (name || "").trim();
  if (!trimmed) return "?";
  const hasKorean = /[가-힣]/.test(trimmed);
  if (hasKorean) {
    const korean = trimmed.replace(/[^가-힣]/g, "");
    return korean.length >= 2 ? korean.slice(-2) : korean;
  }
  const alphanumeric = trimmed.replace(/[^a-zA-Z0-9]/g, "");
  return alphanumeric.slice(0, 2).toUpperCase() || trimmed.charAt(0);
}
const AVATAR_TINTS = [
  { bg: INBODY_COLORS.brand[50], fg: INBODY_COLORS.brand[600] },
  { bg: INBODY_COLORS.blue[50], fg: INBODY_COLORS.blue[600] },
  { bg: INBODY_COLORS.green[50], fg: INBODY_COLORS.green[700] },
  { bg: INBODY_COLORS.purple[50], fg: INBODY_COLORS.purple[600] },
  { bg: INBODY_COLORS.orange[50], fg: INBODY_COLORS.orange[600] }
];
function getAvatarTintIndex(name) {
  const value = name || "";
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = hash * 31 + value.charCodeAt(i) >>> 0;
  }
  return hash % AVATAR_TINTS.length;
}
function getAvatarTint(name) {
  return AVATAR_TINTS[getAvatarTintIndex(name)];
}
export {
  AVATAR_TINTS,
  getAvatarInitial,
  getAvatarTint,
  getAvatarTintIndex
};
